(() => {
  if(!document.querySelector('#product-grid,.zv7-products'))return;
  const urlKey=()=>{const url=new URL(location.href);url.searchParams.delete('preview_theme_id');url.hash='';return 'zico:listing:'+url.pathname+url.search;};
  const store=state=>{try{sessionStorage.setItem(urlKey(),JSON.stringify(state));}catch{}};
  const read=()=>{try{return JSON.parse(sessionStorage.getItem(urlKey())||'null');}catch{return null;}};
  let restoring=false;
  const cards=()=>[...document.querySelectorAll('#product-grid>li,.zv7-products>li')];
  const id=card=>card.querySelector('[data-z-card-key]')?.dataset.zCardKey||card.querySelector('a[href*="/products/"]')?.getAttribute('href');
  const save=()=>{
    if(restoring)return;
    const anchor=cards().find(card=>card.getBoundingClientRect().bottom>0);
    store({y:scrollY,key:anchor&&id(anchor),top:anchor?.getBoundingClientRect().top,pages:history.state?.zicoPages||[],x:[...document.querySelectorAll('.zv7-products')].map(track=>track.scrollLeft),at:Date.now()});
  };
  document.addEventListener('click',event=>{if(event.target.closest('a[href*="/products/"]'))save();},{capture:true});
  window.addEventListener('pagehide',save);
  window.addEventListener('pageshow',async event=>{
    if(event.persisted)return;
    const back=performance.getEntriesByType('navigation')[0]?.type==='back_forward';
    const state=read();if(!back||!state||Date.now()-state.at>86400000)return;
    restoring=true;
    const wanted=state.pages||[];
    history.replaceState({...history.state,zicoPages:[]},'');
    for(const page of wanted.slice(0,20)) {
      if(history.state?.zicoPages?.includes(page))continue;
      const link=document.querySelector('[data-z-next]');if(!link)break;
      const completed=new Promise(resolve=>{
        const timeout=setTimeout(()=>{document.removeEventListener('zico:products-appended',done);resolve(false);},21000);
        const done=e=>{if(!e.detail.sectionId)return;clearTimeout(timeout);document.removeEventListener('zico:products-appended',done);resolve(true);};
        document.addEventListener('zico:products-appended',done);
      });
      link.click();if(!await completed)break;
    }
    await document.fonts?.ready;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      const anchor=cards().find(card=>id(card)===state.key);
      const y=anchor?scrollY+anchor.getBoundingClientRect().top-state.top:state.y;
      window.scrollTo({top:y,behavior:'instant'});
      document.querySelectorAll('.zv7-products').forEach((track,i)=>track.scrollLeft=state.x?.[i]||0);
      restoring=false;
      document.dispatchEvent(new CustomEvent('zico:listing-restored'));
    }));
  });
})();
